import { render, staticRenderFns } from "./IntroScreenTwo.vue?vue&type=template&id=fb352c04&scoped=true&lang=pug&"
import script from "./IntroScreenTwo.vue?vue&type=script&lang=js&"
export * from "./IntroScreenTwo.vue?vue&type=script&lang=js&"
import style0 from "./IntroScreenTwo.vue?vue&type=style&index=0&id=fb352c04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb352c04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VImg,VList,VListItem,VMenu,VRow,VSpacer})
